import { IProjectSpaceTypeCategoriesState } from 'spw-redux/modules/project-space-type-categories/types';
import {
  Actions,
  GET_PROJECT_SPACE_TYPE_CATEGORY_USAGE,
  SET_CAN_DELETE_SUBCATEGORY,
  SET_ASSOCIATED_SPACE_TYPES_AND_WORKSHEETS,
  SET_ASSOCIATED_SPACE_TYPES_AND_FLOORPLANS,
} from 'spw-redux/modules/project-space-type-categories/actions';
import { CanDeleteEnum } from 'spw-shared/types';

const initialState: IProjectSpaceTypeCategoriesState = {
  canDeleteSubcategory: CanDeleteEnum.FALSE,
  associatedSpaceTypes: 0,
  associatedWorksheets: 0,
  associatedFloorplans: 0,
};

const reducer = (
  state: IProjectSpaceTypeCategoriesState = initialState,
  action: Actions
) => {
  switch (action.type) {
    case GET_PROJECT_SPACE_TYPE_CATEGORY_USAGE: {
      return {
        ...state,
        canDeleteSubcategory: CanDeleteEnum.QUERYING,
      };
    }
    case SET_CAN_DELETE_SUBCATEGORY: {
      return {
        ...state,
        canDeleteSubcategory: action.payload.canDelete,
      };
    }
    case SET_ASSOCIATED_SPACE_TYPES_AND_WORKSHEETS:
      return {
        ...state,
        associatedSpaceTypes: action.payload.associatedSpaceTypes,
        associatedWorksheets: action.payload.associatedWorksheets,
      };
    case SET_ASSOCIATED_SPACE_TYPES_AND_FLOORPLANS:
      return {
        ...state,
        associatedSpaceTypes: action.payload.associatedSpaceTypes,
        associatedFloorplans: action.payload.associatedFloorplans,
      };
    default:
      return state;
  }
};

export default reducer;
